/*eslint no-unused-vars: ["error", { "args": "none" }]*/
import {
  AnagraficaApi,
  AuthApi,
  AuthResponseDto,
  Configuration,
  CreateMembershipDto,
  FindAllStatusEnum,
  GenericResponseDto,
  LoginDto,
  Membership,
  MembershipApi,
  SettingsApi,
  SignupDto,
  UpdateMembershipDto,
  User,
} from "@/generated-sources/anagrafica-api";
import { AdminFilters, UserFilters } from "@/models/filters.models";
import {
  CreateTournamentRequest,
  ModifyTournamentRequest,
} from "@/models/tournaments.models";
import { MutationTypes } from "@/store/mutation-types";
import { store } from "@/store/store";
// AWS Amplify API removed - using axios instead
import axios from "axios";

// Funzione asincrona mantenuta per compatibilità (wrapper)
const getIdToken = () => {
  return store.getters.getTokens.idToken;
};

// Refresh helper (kept for backward compatibility)
export async function refreshSessionToken(refreshToken: string, username: string): Promise<AuthResponseDto> {
  try {
    const path = `/v2/auth/refreshToken`;
    const configs = {
      headers: {
        Authorization: `Bearer ${refreshToken}`,
      },
    };
    const response = await axios.post(path, { username }, configs);
    return response.data as AuthResponseDto;
  } catch (error) {
    throw error;
  }
}

// INIT AXIOS
axios.defaults.baseURL = `${process.env.VUE_APP_API_ENDPOINT}`;
axios.defaults.headers.common["Accept"] = `application/json`;
axios.defaults.headers.common["Content-Type"] = `application/json`;

// Move interceptor logic to AuthHttp class
import { AuthHttp } from "@/api/auth-http";
import { client } from "../client-v2";

const authHttp = new AuthHttp(
  axios,
  async () => {
    // Lettura sincrona dallo store invece di dispatch asincrono
    const tokens = store.getters.getTokens as any;
    return { accessToken: tokens.accessToken, idToken: tokens.idToken, refreshToken: tokens?.refreshToken };
  },
  () => (store.getters as any).getUser,
  (payload: any) => {
    client.forceUpdateTokens(payload);
    store.commit(MutationTypes.WRITE_TOKENS, payload);
  },
  {
    refreshPath: "/v2/auth/refreshToken",
  }
);

authHttp.initInterceptors();

const configuration = new Configuration({
  basePath: process.env.VUE_APP_API_ENDPOINT,
  accessToken: () => {
    // Lettura sincrona dallo store invece di dispatch asincrono
    const tokens = store.getters.getTokens as any;
    return tokens.accessToken;
  },
});
const authApi = new AuthApi(configuration);
const anagraficaApi = new AnagraficaApi(configuration);
const settingsApi = new SettingsApi(configuration);
const membershipApi = new MembershipApi(configuration);

export async function signIn(obj: LoginDto): Promise<AuthResponseDto> {
  try {
    // return await Auth.signIn(obj);
    return (await authApi.login(obj)).data;
  } catch (error) {
    throw error;
  }
}

export async function signOut() {
  try {
    // return await Auth.signOut({ global: false });
    return await authApi.logout();
  } catch (error) {
    throw error;
  }
}

export async function signUp(obj: SignupDto) {
  try {
    // return await Auth.signUp(obj);
    return await authApi.signup(obj);
  } catch (error) {
    throw error;
  }
}

export async function confirmSignUp(username: string, code: string) {
  try {
    // return await Auth.confirmSignUp(username, code);
    return await authApi.signupValidateEmail({
      username,
      confirmationCode: code,
    });
  } catch (error) {
    throw error;
  }
}

export async function resendSignUp(username: string) {
  try {
    // return await Auth.resendSignUp(username);
    return await authApi.resendSignupValidateEmailCode({ username });
  } catch (error) {
    throw error;
  }
}

export async function forgotPassword(username: string) {
  try {
    // return await Auth.forgotPassword(username);
    return await authApi.resetPassword({ username });
  } catch (error) {
    throw error;
  }
}

export async function forgotPasswordSubmit(
  username: string,
  code: string,
  new_password: string
) {
  try {
    // return await Auth.forgotPasswordSubmit(username, code, new_password);
    return await authApi.resetPasswordConfirm({
      username,
      confirmationCode: code,
      newPassword: new_password,
    });
  } catch (error) {
    throw error;
  }
}

export async function completeNewPassword(
  username: string,
  confirmationCode: string,
  newPassword: string
  // user: CognitoUser,
  // newPassword: string,
  // requiredAttributes: object
): Promise<GenericResponseDto> {
  try {
    // return await Auth.completeNewPassword(
    //   user,
    //   newPassword,
    //   requiredAttributes
    // );
    return (
      await authApi.resetPasswordConfirm({
        username,
        confirmationCode,
        newPassword,
      })
    ).data;
  } catch (error) {
    throw error;
  }
}

// export async function updateUserAttributes(
//   user: CognitoUser,
//   attributes: object
// ) {
//   try {
//     return await Auth.updateUserAttributes(user, attributes);
//   } catch (error) {
//     throw error;
//   }
// }
export async function updatePhoneNumber(id: string, phonenumber: string) {
  try {
    return await anagraficaApi.userChangePhoneNumber(id, {
      phonenumber,
    });
  } catch (error) {
    throw error;
  }
}

export async function verifyUserAttribute(): Promise<GenericResponseDto> {
  // user: CognitoUser,
  // attr: string
  try {
    // return await Auth.verifyUserAttribute(user, attr);
    return (await authApi.requestSms()).data;
  } catch (error) {
    throw error;
  }
}

// export async function currentAuthenticatedUser() {
//   try {
//     return await Auth.currentAuthenticatedUser();
//   } catch (error) {
//     throw error;
//   }
// }

export async function verifySmsCode(code: string) {
  // const apiName = "WeSmashApi";
  // const path = `/verify-sms-code`;
  // const myInit = {
  //   headers: {
  //     Authorization: "Bearer " + (await getIdToken()),
  //   },
  //   body: {
  //     access_token: await getAccessToken(),
  //     code,
  //   },
  // };
  // return API.post(apiName, path, myInit);
  return (await authApi.verifySms({ code })).data;
}

export async function myUserInfo(): Promise<User> {
  // const apiName = "WeSmashApi";
  // const path = "/user-info";
  // const myInit = {
  //   // OPTIONAL
  //   headers: {
  //     Authorization: "Bearer " + (await getIdToken()),
  //   }, // OPTIONAL
  // };

  // return API.get(apiName, path, myInit);
  return (await anagraficaApi.getCurrentUserInformation()).data.user;
}

export async function postUserInfo(id: string, user: User) {
  //  const apiName = "WeSmashApi";
  //  const path = "/user-info";
  //  const myInit = {
  //    // OPTIONAL
  //    headers: {
  //      Authorization: "Bearer " + (await getIdToken()),
  //    }, // OPTIONAL
  //    body: user,
  //  };

  //  return API.post(apiName, path, myInit);
  return (await anagraficaApi.updateUser(id, user)).data;
}

export async function clubRequests(filters: AdminFilters) {
  const path = "/admin/requests";
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  if (filters) {
    configs["params"] = filters;
  }
  return axios.get(path, configs);
}

export async function getUserInfo(id: string) {
  const path = `/admin/users/${id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.get(path, configs);
}

export async function changeRequestStatus(status: string, club_id: string) {
  const path = `/admin/requests/${club_id}/${status}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.post(path, {}, configs);
}

export async function myClubs() {
  const path = `/my-clubs`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.get(path, configs);
}

export async function changeClubInfo(club_id: string, payload) {
  const path = `/clubs/${club_id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.put(path, payload, configs);
}

export async function getPlaygroundInfo(
  club_id: string,
  playground_id: string
) {
  const path = `/clubs/${club_id}/playgrounds/${playground_id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.get(path, configs);
}

export async function addPlayground(club_id: string, payload) {
  const path = `/clubs/${club_id}/playgrounds`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.post(path, payload, configs);
}

export async function changePlaygroundInfo(
  club_id: string,
  playground_id: string,
  payload
) {
  const path = `/clubs/${club_id}/playgrounds/${playground_id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.put(path, payload, configs);
}

export async function deletePlayground(club_id: string, playground_id: string) {
  const path = `/clubs/${club_id}/playgrounds/${playground_id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.delete(path, configs);
}

export async function changeProfilePic(_picture: string) {
  const path = `/profile-picture`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.post(path, { picture: _picture }, configs);
}

export async function addNewClub(payload: { club: any }) {
  const path = `/clubs`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
      // "recaptcha-token": payload.token,
    },
  };
  return axios.post(path, payload.club, configs);
}

export async function getCalendarEvents(payload: {
  club_id: string;
  date?: string;
  start_date?: string;
  user_id?: string;
  future?: boolean;
  archived?: boolean;
  deleted?: boolean;
  hideLoader?: boolean;
}) {
  const path = `/timeslots/get-calendar`;
  const params = {};
  params["club_id"] = payload.club_id;

  if (payload.start_date !== undefined) {
    params["start_date"] = payload.start_date;
  }
  if (payload.date !== undefined) {
    params["date"] = payload.date;
  }
  if (payload.user_id !== undefined) {
    params["user_id"] = payload.user_id;
  }
  if (payload.future !== undefined) {
    params["future"] = payload.future;
  }
  if (payload.archived !== undefined) {
    params["archived"] = payload.archived;
  }
  if (payload.deleted !== undefined) {
    params["deleted"] = payload.deleted;
  }

  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
    params: params,
  };
  return axios.get(path, configs);
}

export async function getUsers(club_id: string, filters?: UserFilters) {
  const path = `/clubs/${club_id}/users`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  if (filters) {
    configs["params"] = filters;
  }

  return axios.get(path, configs);
}

export async function getUsersAxios(club_id: string, filters?: UserFilters) {
  const queryString = [];

  if (filters.limit != null) {
    queryString.push(`limit=${filters.limit}`);
  }
  if (filters.page != null) {
    queryString.push(`page=${filters.page}`);
  } else {
    queryString.push("page=1");
  }
  if (filters.name != null) {
    queryString.push(`name=${filters.name}`);
  }
  if (filters.banned != null) {
    queryString.push(`banned=${filters.banned}`);
  }
  if (filters.min_bookings != null) {
    queryString.push(`min_bookings=${filters.min_bookings}`);
  }
  if (filters.min_cancellations != null) {
    queryString.push(`min_cancellations=${filters.min_cancellations}`);
  }

  const myInit = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };

  const path = `/clubs/${club_id}/users?${queryString.join("&")}`;

  const resp = await axios.get(path, myInit);
  // for (const index in resp.data.records) {
  //   console.log(resp.data.records[index]['id']);
  // }
  return resp;
}
export async function findUsersClubs(clubId: string, filters?: UserFilters) {
  const queryString = [];

  if (filters.limit != null) {
    queryString.push(`limit=${filters.limit}`);
  }
  if (filters.page != null) {
    queryString.push(`page=${filters.page}`);
  } else {
    queryString.push("page=1");
  }
  if (filters.name != null) {
    queryString.push(`name=${filters.name}`);
  }
  if (filters.banned != null) {
    queryString.push(`banned=${filters.banned}`);
  }
  if (filters.min_bookings != null) {
    queryString.push(`min_bookings=${filters.min_bookings}`);
  }
  if (filters.min_cancellations != null) {
    queryString.push(`min_cancellations=${filters.min_cancellations}`);
  }

  const myInit = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };

  const path = `/clubs/${clubId}/users?${queryString.join("&")}`;

  const resp = await axios.get(path, myInit);
  // for (const index in resp.data.records) {
  //   console.log(resp.data.records[index]['id']);
  // }
  return resp;
}

export async function banUser(club_id: string, user_id: string) {
  const path = `/clubs/${club_id}/users/${user_id}/ban`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.post(path, {}, configs);
}

export async function unbanUser(club_id: string, user_id: string) {
  const path = `/clubs/${club_id}/users/${user_id}/unban`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.post(path, {}, configs);
}

export async function getClubStats(club_id: string, start_date: string) {
  const path = `/clubs/${club_id}/statistics`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
    params: {
      start_date: start_date,
    },
  };
  return axios.get(path, configs);
}

export async function getCustomerStats(club_id: string, start_date: string) {
  const path = `/admin/statistics`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
    params: {
      club_id: club_id,
      start_date: start_date,
    },
  };
  return axios.get(path, configs);
}

export async function addBooking(booking) {
  const path = `/backoffice/bookings`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.post(path, booking, configs);
}

export async function modifyBooking(booking) {
  const path = `/backoffice/bookings`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.put(path, booking, configs);
}

export async function clubSearch(nameFilter: string) {
  const path = `/admin/clubs`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  if (nameFilter) {
    configs["params"] = { name: nameFilter };
  }
  return axios.get(path, configs);
}

export async function clubDetail(club_id: string) {
  const path = `/admin/clubs/${club_id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.get(path, configs);
}

export async function enableClub(club_id: string) {
  const path = `/admin/clubs/${club_id}/enable`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.post(path, {}, configs);
}

export async function disableClub(club_id: string) {
  const path = `/admin/clubs/${club_id}/disable`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.post(path, {}, configs);
}

export async function sendOTP(phone_number: string) {
  const path = `/send-otp`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
    params: {
      phone_number: phone_number,
    },
  };
  return axios.post(path, {}, configs);
}

export async function deleteTimeslot(booking) {
  const path = `/backoffice/bookings/cancel`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };

  return axios.post(path, booking, configs);
}

export async function createTournament(
  club_id: string,
  tournament: CreateTournamentRequest
) {
  const path = `/clubs/${club_id}/tournaments`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.post(path, tournament, configs);
}

export async function modifyTournament(
  club_id: string,
  tournament_id: string,
  tournament: ModifyTournamentRequest
) {
  const path = `/clubs/${club_id}/tournaments/${tournament_id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.put(path, tournament, configs);
}

export async function deleteTournament(club_id: string, tournament_id: string) {
  const path = `/clubs/${club_id}/tournaments/${tournament_id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.delete(path, configs);
}

export async function getTournaments(club_id: string) {
  const path = `/clubs/${club_id}/tournaments`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.get(path, configs);
}

export async function getTournamentDetails(
  club_id: string,
  tournament_id: string
) {
  const path = `/clubs/${club_id}/tournaments/${tournament_id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.get(path, configs);
}

export async function getTournamentTeams(
  club_id: string,
  tournament_id: string
) {
  const path = `/clubs/${club_id}/tournaments/${tournament_id}/teams`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.get(path, configs);
}

export async function deleteTeam(
  club_id: string,
  tournament_id: string,
  booker_id: string
) {
  const path = `/clubs/${club_id}/tournaments/${tournament_id}/teams/${booker_id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.delete(path, configs);
}

export async function uploadScoreboard(
  club_id: string,
  tournament_id: string,
  payload: { scoreboard: string }
) {
  const path = `/clubs/${club_id}/tournaments/${tournament_id}/scoreboard `;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.post(path, payload, configs);
}

export async function getPricesRules(params: object) {
  const path = `rule`;
  const configs = {
    params: {
      ...params,
    },
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.get(path, configs);
}

export async function getPriceRule(id: string) {
  const path = `rule/${id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.get(path, configs);
}

export async function createPricesRule(form: object) {
  const path = `rule`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.post(path, form, configs);
}

export async function updatePriceRule(payload: { id: string; body: object }) {
  const path = `rule/${payload.id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.patch(path, payload.body, configs);
}

export async function deletePriceRule(id: string) {
  const path = `rule/${id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.delete(path, configs);
}

export async function getExceptionRules(params: object) {
  const path = `exception-rule`;
  const configs = {
    params: {
      ...params,
    },
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.get(path, configs);
}

export async function createExceptionRule(form: object) {
  const path = `exception-rule`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.post(path, form, configs);
}

export async function updateExceptionRule(payload: {
  id: string;
  body: object;
}) {
  const path = `exception-rule/${payload.id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.patch(path, payload.body, configs);
}

export async function deleteExceptionRule(id: string) {
  const path = `exception-rule/${id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.delete(path, configs);
}

export async function duplicatePlayground(
  club_id: string,
  id: string,
  name: string
) {
  const path = `/clubs/${club_id}/playgrounds/${id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
    timeout: 200 * 1000,
  };
  return axios.post(path, { name: name }, configs);
}

export async function checkBundle(bookings) {
  const path = `/backoffice/bundles/check`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
    timeout: 200 * 1000,
  };
  return axios.post(path, bookings, configs);
}

export async function confirmBundle(bookings) {
  const path = `/backoffice/bundles/confirm`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
    timeout: 200 * 1000,
  };
  return axios.post(path, bookings, configs);
}

export async function updateBundle(bookings) {
  const path = `/backoffice/bundles/confirm`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
    timeout: 200 * 1000,
  };
  return axios.post(path, bookings, configs);
}

export async function uploadBookingCSV(
  club_id: string,
  id: string,
  file: File
) {
  const path = `/import/${club_id}/${id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
      "Content-Type": "multipart/form-data",
    },
  };

  const formData = new FormData();
  formData.append("file", file);

  // RETURN
  return axios.post(path, formData, configs);
}

export async function getCards(user_id: string, limit = 10, club_id?: string) {
  const path = `cards`;
  const configs = {
    params: {
      club_id: club_id || undefined,
      user_id: user_id,
      limit: limit,
    },
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };

  // RETURN
  return axios.get(path, configs);
}

export async function getCard(card_id: string) {
  const path = `cards/${card_id}`;
  const configs = {
    params: {},
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };

  // RETURN
  return axios.get(path, configs);
}

export async function createCard(form: object) {
  const path = `cards`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.post(path, form, configs);
}

export async function updateCard(form: any) {
  const path = `cards/${form.id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  delete form.id;
  return axios.patch(path, form, configs);
}

export async function deleteCard(form: any) {
  const path = `cards/${form.id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.delete(path, configs);
}


export async function getUser(club_id: string, user_id: string) {
  const path = `/clubs/${club_id}/users/${user_id}`;
  const configs = {
    // OPTIONAL
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    }, // OPTIONAL
  };

  return axios.get(path, configs);
}

export async function changePlayerCategory(
  club_id: string,
  user_id: string,
  category: string
) {
  const path = `/clubs/${club_id}/users/${user_id}`;
  const configs = {
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return axios.put(path, { player_category: category }, configs);
}

export async function getOpenGames(
  club_id: string,
  match_type?: string,
  status?: string
) {
  const path = `bookings/open-games`;
  const configs = {
    params: {
      club_id: club_id,
      match_type: match_type || undefined,
      status: status,
    },
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };

  // RETURN
  return axios.get(path, configs);
}

export async function getOpenGame(id: string) {
  const path = `bookings/${id}`;
  const configs = {
    params: {},
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };

  // RETURN
  return axios.get(path, configs);
}

export async function subscribeToGame(
  booking_id: string,
  wesmash_user_id: string,
  spot: number
) {
  const path = `bookings/${booking_id}/subscribe`;
  const body = {
    wesmash_user_id: wesmash_user_id,
    spot: spot,
  };
  const configs = {
    params: {},
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };

  // RETURN
  return axios.post(path, body, configs);
}

export async function unsubscribeToGame(
  booking_id: string,
  wesmash_user_id: string
) {
  const path = `bookings/${booking_id}/unsubscribe`;
  const body = {
    wesmash_user_id: wesmash_user_id,
  };
  const configs = {
    params: {},
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };

  // RETURN
  return axios.post(path, body, configs);
}

export async function adminUserStats(month: string, year: string) {
  const path = `clubs/full-statistics?month=${month}&year=${year}`;
  // const path = `bookings/admin-search?club_id=${club_id}&start_date=${start_at}`;

  const configs = {
    params: {},
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };

  // RETURN
  const results = [];
  let resp = await axios.get(path, configs);
  const totalPages = resp.data.pagination.totalPages;

  results.push(Object.entries(resp.data.records));

  for (let i = 2; i <= totalPages; i++) {
    resp = await axios.get(`${path}&page=${i} `, configs);
    results.push(Object.entries(resp.data.records));
  }

  return { results: results };
}

export async function nexiSaveConfig(
  club_id: string,
  mac: string,
  alias: string
) {
  const path = `clubs/${club_id}/nexi-payment-codes`;
  const body = {
    alias: alias,
    mac: mac,
  };
  const configs = {
    params: {
      alias: alias,
      mac: mac,
    },
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };

  return await axios.post(path, body, configs);
}

export async function enableOnlinePayment(club_id: string, enable: boolean) {
  const path = `clubs/${club_id}/enable-online-payment`;
  const body = {
    online_payment: enable,
  };
  const configs = {
    params: {},
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };

  return await axios.post(path, body, configs);
}

export async function fetchTransactions(
  club_id: string,
  refund: boolean,
  date: string
) {
  const path = "transactions";

  const configs = {
    params: {
      club_id: club_id,
      type: refund ? "REFUND" : "SALE",
      payment_date: date,
    },
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return await axios.get(path, configs);
}

export async function refund(
  clubId: string,
  bookingId: string,
  refundPercentage: number
) {
  const path = `clubs/${clubId}/refund_payment`;
  const body = {
    booking_id: bookingId,
    refund_percentage: refundPercentage,
  };
  const configs = {
    params: {},
    headers: {
      Authorization: "Bearer " + (await getIdToken()),
    },
  };
  return await axios.post(path, body, configs);
}

export async function getMemberships(
  clubId: string,
  userId: string,
  status: FindAllStatusEnum,
  page?: number,
  limit?: number,
  sortBy?: string,
  sortDirection?: string,
  activationDateFrom?: string,
  activationDateTo?: string,
  expirationDateFrom?: string,
  expirationDateTo?: string,
  descriptionLike?: string
): Promise<Membership[] | {
  data: Membership[];
  currentPage: number;
  limit: number;
  hasNextPage: boolean;
  count: number;
}> {
  // Costruisco le opzioni per la chiamata API
  const options: any = {};

  // Aggiungo tutti i parametri disponibili
  const hasParams = page || limit || sortBy || sortDirection ||
    activationDateFrom || activationDateTo ||
    expirationDateFrom || expirationDateTo ||
    descriptionLike;

  if (hasParams) {
    options.params = {};

    // Parametri di paginazione e sorting
    if (page) options.params.page = page.toString();
    if (limit) options.params.limit = limit.toString();
    if (sortBy) options.params.sortBy = sortBy;
    if (sortDirection) options.params.sortDirection = sortDirection;

    // Parametri di filtro aggiuntivi
    if (activationDateFrom) options.params.activationDateFrom = activationDateFrom;
    if (activationDateTo) options.params.activationDateTo = activationDateTo;
    if (expirationDateFrom) options.params.expirationDateFrom = expirationDateFrom;
    if (expirationDateTo) options.params.expirationDateTo = expirationDateTo;
    if (descriptionLike) options.params.descriptionLike = descriptionLike;
  }

  // Uso sempre la stessa chiamata API
  console.log(" >>  await membershipApi.findAll")

  const response = await membershipApi.findAll(clubId, userId, status, options);

  // Controllo runtime se la risposta è paginata verificando la struttura
  const responseData = response.data as any;

  if (responseData && typeof responseData === 'object' && 'data' in responseData) {
    // La risposta è paginata
    return responseData as {
      data: Membership[];
      currentPage: number;
      limit: number;
      hasNextPage: boolean;
      count: number;
    };
  } else {
    // La risposta è un array semplice
    return responseData as Membership[];
  }
}

export async function addMembership(membership: CreateMembershipDto) {
  return (await membershipApi.create(membership)).data;
}

export async function updateMembership(
  id: string,
  membership: UpdateMembershipDto
) {
  console.log(">>> updateMembership")
  return (await membershipApi.update(id, membership)).data;
}

export async function deleteMembership(id: string) {
  return await membershipApi.remove(id);
}

export async function updateDeliverWelcomeKit(id: string) {
  // return await membershipApi.updateDeliverWelcomeKit(id);
  return await membershipApi.markWelcomeKitDelivered(id);
}

export async function getUserById(userId: string) {
  try {
    return await anagraficaApi.getUserById(userId);
  } catch (error) {
    throw error;
  }
}
export async function getConfigSystemPublic() {
  try {
    return await settingsApi.getConfigSystemPublic();
  } catch (error) {
    throw error;
  }
}
